// extracted by mini-css-extract-plugin
export var dropOver = "_kf-2";
export var dropValid = "_kf-1";
export var hidden = "_kf-3";
export var line = "_kf-0";